import {
	SET_END_DATE, SET_END_TIME, SET_START_DATE, SET_START_TIME
} from "./DateTimePickerActionsType";

const mutations = {
	[SET_START_DATE]: (state, data) =>
	{
		state.dateTime.startDate = data;
	},
	[SET_START_TIME]: (state, time) =>
	{
		state.dateTime.startTime = time;
	},
	[SET_END_DATE]: (state, date) =>
	{
		state.dateTime.endDate = date;
	},
	[SET_END_TIME]: (state, time) =>
	{
		state.dateTime.endTime = time;
	},
};

export default { mutations };